// LibraryReleaseService (zou, via sabaody) client — SAD-461 release + reuse.
import { createClient } from '@connectrpc/connect';
import { LibraryReleaseService } from '../../../../../gen/ts/mono/projectdata/v1/library_release_connect';
import { connectTransport } from '../../lib/connect/transport';
export const libraryReleaseClient = createClient(LibraryReleaseService, connectTransport);
